import template from './index.pug'
import AiInfinityRuleForm from '../components/_form.js'

export default Vue.extend({
  template : template(),
  components: {
    AiInfinityRuleForm
  },
  methods: {
    t(key) {
      return this.$t(`aiInfinityRules.new.${key}`);
    }
  }
})